import type {
    IPenciledInputs,
    OfferType,
    GenericObject,
    PenciledInputOfferType,
    IPencilOfferInputs
} from '@makemydeal/dr-platform-types';
import { REQUEST_LEASE_CONTRACT_FIELDS, SELECTED_ANNUAL_MILES } from '../types/actionTypes';

export const changesAnnualMiles = (action: { type: string; payload?: GenericObject }): boolean =>
    action.type === SELECTED_ANNUAL_MILES ||
    (action.type === REQUEST_LEASE_CONTRACT_FIELDS && Boolean(action.payload?.meta?.changedFields?.includes('annualMiles')));

export const buildLeaseContractFieldsPenciledInputsState = (
    penciledInputs: IPenciledInputs,
    overrides: GenericObject,
    offerType: OfferType
): IPenciledInputs => {
    const annualMiles = overrides?.annualMiles || penciledInputs?.byOfferType?.[offerType]?.annualMiles;
    return {
        ...penciledInputs,
        byOfferType: {
            ...penciledInputs?.byOfferType,
            [offerType]: {
                annualMiles,
                ...penciledInputs?.byOfferType?.[offerType],
                isUpdatedByUser: true,
                ...overrides
            }
        } as { [offerType in PenciledInputOfferType]: IPencilOfferInputs }
    };
};
